import { createAction, props } from '@ngrx/store';

// TODO: Use StoreTypes enum after in Q3 release
export const setTFAStatus = createAction(`[TFA] Set TFA Status`, props<{ isEnabled: boolean }>());
export const loadTFAStatus = createAction(`[TFA] Load TFA Status`);
